module.exports = __webpack_public_path__ + "static/media/Pink Rathian.e45c4b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Pink Rathian.png
// module id = 129
// module chunks = 0